<template>
  <div class="mypage-settings py-4">
    <div class="row">
      <div class="col-lg-3 mb-4 mb-lg-0">
        <div class="guide-panel border rounded p-3 h-100">
          <img
            :src="guideImage"
            alt="My page message guide"
            class="img-fluid guide-image border rounded"
          />
        </div>
      </div>
      <div class="col-lg-9">
        <div class="d-flex flex-column gap-3">
          <mypage-message-editor
            :selected-language="selectedLanguages.A"
            setting-key="A"
            title-key="dashboard-settings.mypage-message-1"
            @change-language="updateSelectedLanguage('A', $event)"
          />
          <mypage-message-editor
            :selected-language="selectedLanguages.B"
            setting-key="B"
            title-key="dashboard-settings.mypage-message-2"
            @change-language="updateSelectedLanguage('B', $event)"
          />
          <mypage-message-editor
            :selected-language="selectedLanguages.C"
            setting-key="C"
            title-key="dashboard-settings.mypage-message-3"
            @change-language="updateSelectedLanguage('C', $event)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MypageMessageEditor from "./MypageMessageEditor";
import guideImage from "@/assets/img/mypage-message-guide.png";

export default {
  components: {
    MypageMessageEditor
  },
  data() {
    return {
      selectedLanguages: {
        A: "ja",
        B: "ja",
        C: "ja"
      }
    };
  },
  computed: {
    guideImage() {
      return guideImage;
    }
  },
  methods: {
    updateSelectedLanguage(settingKey, lang) {
      this.selectedLanguages = {
        ...this.selectedLanguages,
        [settingKey]: lang
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.guide-panel {
  background-color: #fff;
}

.guide-image {
  width: calc(100% - 16px);
  background-color: #f8f9fc;
  margin: 0 auto;
  display: block;
}

.gap-3 > * + * {
  margin-top: 1rem;
}
</style>
